export default "__VITE_ASSET__YfPZTwys__"